export default __webpack_public_path__ + "static/media/cardcustom.bd6f94c9.webp";